import React from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useConfig from "app/hooks/useConfig";
import useLogout from "app/hooks/useLogout";
import { onClickBehavior } from "app/utils";
import { Svg } from "app/components";
import { List, Item } from "./styles";
import { linkTo } from "utils";
import { generateUniqueId } from 'utils';

const propTypes = {
  isRounded: PropTypes.bool
};

const defaultProps = {
  isRounded: false
};

const Menu = ({ isRounded }) => {
  const [t] = useTranslation();
  const { routes, showingOptions } = useConfig();
  const logout = useLogout();
  const clickBehavior = isRounded ? onClickBehavior : {};

  const handleLogout = () => {
    localStorage.setItem("logout", true);
    localStorage.removeItem("hasReloadedOnLogin");
    logout();
  }


  return (
    <List isRounded={isRounded} {...clickBehavior}>
      <Item id={`menu-item-${generateUniqueId()}`}>
        <NavLink
          className="menu__link"
          to={linkTo(routes.user.pattern)}
          activeClassName="_active"
          id={`menu-link-${generateUniqueId()}`}
          tabIndex="0"
        >
          <Svg id="account" />
          <span>{t("common.my_account")}</span>
        </NavLink>
      </Item>

      <Item id={`menu-item-${generateUniqueId()}`}>
        <NavLink
          className="menu__link"
          to={linkTo(routes.tickets.pattern)}
          activeClassName="_active"
          id={`menu-link-${generateUniqueId()}`}
          tabIndex="0"
        >
          <Svg id="tickets" />
          <span>{t("common.my_tickets")}</span>
        </NavLink>
      </Item>

      {/* <Item>
        <NavLink
          className="menu__link"
          // to={routes.xXtraCard.patterns}
          to={routes.xXtraCard.pattern}
          activeClassName="_active"
        >
          <Svg id="bonus-card-2" />
          <span>{t("common.xXtra_card")}</span>
        </NavLink>
      </Item> */}

      {showingOptions?.myBonusCard && (
        <Item id={`menu-item-${generateUniqueId()}`}>
          <NavLink
            className="menu__link"
            to={linkTo(routes.bonusCard.pattern)}
            activeClassName="_active"
            exact
            id={`menu-link-${generateUniqueId()}`}
            tabIndex="0"
          >
            <Svg id="bonus-card-2" />
            <span>{t("common.xXtra_card")}</span>
            {/* <span>{t('common.my_bonus_card')}</span> */}
          </NavLink>
        </Item>
      )}

      {showingOptions?.myGiftCard && (
        <Item id={`menu-item-${generateUniqueId()}`}>
          <NavLink
            className="menu__link"
            to={linkTo(routes.giftCard.pattern)}
            activeClassName="_active"
            exact
            id={`menu-link-${generateUniqueId()}`}
            tabIndex="0"
          >
            <Svg id="gift-card" />
            <span>{t("common.my_giftcards")}</span>
          </NavLink>
        </Item>
      )}

      <Item id={`menu-item-${generateUniqueId()}`}>
        <NavLink
          className="menu__link"
          to={linkTo(routes.history.pattern)}
          activeClassName="_active"
          exact
          id={`menu-link-${generateUniqueId()}`}
          tabIndex="0"
        >
          <Svg id="history" />
          <span>{t("common.my_history")}</span>
        </NavLink>
      </Item>

      {showingOptions?.whatchList && (
        <Item id={`menu-item-${generateUniqueId()}`}>
          <NavLink
            className="menu__link"
            to={linkTo(routes.whatchList.pattern)}
            activeClassName="_active"
            exact
            id={`menu-link-${generateUniqueId()}`}
            tabIndex="0"
          >
            <Svg id="heart" />
            <span>{t("common.my_watchList")}</span>
          </NavLink>
        </Item>
      )}

      <Item id={`menu-item-${generateUniqueId()}`}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            handleLogout();
          }
        }}
        tabIndex={0}>
        <button type="button" className="menu__link" onClick={() => handleLogout()} tabIndex="0">
          <Svg id="logout" />
          <span>{t("common.logout")}</span>
        </button>
      </Item>
    </List >
  );
};

Menu.propTypes = propTypes;
Menu.defaultProps = defaultProps;
export default Menu;
